import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../Styles/accountDropdown.scss';

const AccountDropdown = ({ onMenuClose, onOpenLicenseUpgrade }) => {
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const accountDropdownRef = useRef(null);
  const { user, signOut, subscriptionActive, hasActiveLicense, hasActiveSubscription, subscriptionLoading } = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountDropdownRef.current && !accountDropdownRef.current.contains(event.target)) {
        setAccountDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      setAccountDropdownOpen(false);
      if (onMenuClose) onMenuClose(); // Close mobile menu if provided
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleDropdownToggle = () => {
    setAccountDropdownOpen(!accountDropdownOpen);
  };

  const handleLinkClick = () => {
    setAccountDropdownOpen(false);
    if (onMenuClose) onMenuClose(); // Close mobile menu when clicking links
  };

  const handleSubscribeNow = () => {
    if (onOpenLicenseUpgrade) {
      onOpenLicenseUpgrade(); // Use the license upgrade function
      setAccountDropdownOpen(false);
      if (onMenuClose) onMenuClose();
    } else {
      console.error('onOpenLicenseUpgrade is undefined');
    }
  };

  if (!user) return null;

  // Get avatar URL from Google OAuth or fallback to default
  const avatarUrl = user.user_metadata?.avatar_url;
  const userName = user.user_metadata?.full_name || user.email;
  const emailInitial = user.email?.charAt(0).toUpperCase() || 'U';


  return (
    <div className="account-dropdown-container svg---text" ref={accountDropdownRef}>



      <button
        onClick={handleDropdownToggle}
        className="svg---text account-btn"
        title="Account"
      >
        {avatarUrl ? (
          <>
            <img
              src={avatarUrl}
              alt="Profile"
              className="account-avatar"
              crossOrigin="anonymous"
              referrerPolicy="no-referrer"
            />
          </>
        ) : (
          <>
            <div
              className="account-avatar-letter"
            >
              {emailInitial}
            </div>
          </>
        )}
      </button>

      <div className={`account-dropdown ${accountDropdownOpen && 'show'}`}>
        <div className="dropdown-header">


          {avatarUrl ? (
            <>
              <img
                src={avatarUrl}
                alt="Profile"
                className="account-avatar--minified"
                crossOrigin="anonymous"
                referrerPolicy="no-referrer"
              />
            </>
          ) : (
            <>
              <div
                className="account-avatar-letter--minified"
              >
                {emailInitial}
              </div>
            </>
          )}
          <div className='user-info-container'>
            <span className="user-name">{userName}</span>
            <span className="member-info">
              <span className="member-status-indicator" style={{ backgroundColor: subscriptionLoading ? '#847F78' : (subscriptionActive ? '#1ACD6A' : '#FF2977') }}></span>

              {subscriptionLoading
                ? 'Checking subscription...'
                : (subscriptionActive
                  ? (hasActiveLicense && !hasActiveSubscription ? '24-Hour Access' : 'Active subscription')
                  : 'No active subscriptions'
                )
              }
            </span>
          </div>

        </div>

        <div className="dropdown-items">
          {hasActiveLicense && !hasActiveSubscription && (
            <button
              onClick={handleSubscribeNow}
              className="upgrade-subscription-btn pri-btn"
            >
              Upgrade to Subscription
            </button>
          )}

          <Link
            to="/subscriptions"
            className="dropdown-item subscription-btn"
            onClick={handleLinkClick}
          >
            <span>{hasActiveLicense && !hasActiveSubscription ? '24-Hour Access Info' : 'Subscriptions'}</span>
          </Link>

          <button
            onClick={handleSignOut}
            className="dropdown-item sign-out-btn"
          >
            <span>Sign out</span>
            <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#211f1c">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDropdown;